<ng-container *ngFor="let element of parsedElements">
  <ng-container [ngSwitch]="element.type">
    <!-- Handle Headers -->
    <tidy-row *ngSwitchCase="'header'">
      <tidy-text
        [header]="element.content"
        [size]="
          element.level === 1
            ? 'large'
            : element.level === 2
            ? 'medium'
            : 'small'
        "
        [translate]="false"
        [class.all-bold]="allBold">
      </tidy-text>
    </tidy-row>

    <!-- Handle Paragraphs -->
    <tidy-row *ngSwitchCase="'paragraph'">
      <ng-container *ngIf="element.formattedContent; else plainParagraph">
        <ng-container *ngFor="let formattedElement of element.formattedContent">
          <ng-container [ngSwitch]="formattedElement.type">
            <span *ngIf="formattedElement.type !== 'paragraph'">&nbsp;</span>
            <!-- Handle Bold Text -->
            <tidy-text
              *ngSwitchCase="'bold'"
              [body]="formattedElement.content"
              [translate]="false"
              [class]="allBold ? 'bold all-bold' : 'bold'"></tidy-text>

            <!-- Handle Italic Text -->
            <tidy-text
              *ngSwitchCase="'italic'"
              [body]="formattedElement.content"
              [translate]="false"
              [class]="allBold ? 'italic all-bold' : 'italic'"></tidy-text>

            <!-- Handle Underline Text -->
            <tidy-text
              *ngSwitchCase="'underline'"
              [body]="formattedElement.content"
              [translate]="false"
              [class]="allBold ? 'underline all-bold' : 'underline'"></tidy-text>

            <!-- Handle Strikethrough Text -->
            <tidy-text
              *ngSwitchCase="'strikethrough'"
              [body]="formattedElement.content"
              [translate]="false"
              [class]="allBold ? 'strikethrough all-bold' : 'strikethrough'"></tidy-text>

            <!-- Handle Links -->
            <tidy-text
              *ngSwitchCase="'link'"
              [actionBody]="formattedElement.content"
              (action)="openLink(formattedElement.url)"
              [class]="allBold ? 'link all-bold' : 'link'"></tidy-text>

            <!-- Handle Paragraphs (plain text) -->
            <tidy-text
              *ngSwitchDefault
              [body]="formattedElement.content"
              [translate]="false"
              [class.all-bold]="allBold"></tidy-text>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-template #plainParagraph>
        <tidy-text [body]="element.content" [translate]="false" [class.all-bold]="allBold"></tidy-text>
      </ng-template>
    </tidy-row>

    <!-- Handle List Items (basic) -->
    <tidy-row *ngSwitchCase="'list'" class="vertical-align-center list-item">
      <span class="bullet">&bull;</span>
      <ng-container *ngIf="element.formattedContent; else plainContent">
        <ng-container *ngFor="let formattedElement of element.formattedContent">
          <ng-container [ngSwitch]="formattedElement.type">
            <span *ngIf="formattedElement.type !== 'paragraph'">&nbsp;</span>
            <!-- Handle Bold Text -->
            <tidy-text
              *ngSwitchCase="'bold'"
              [body]="formattedElement.content"
              [translate]="false"
              [class]="allBold ? 'bold all-bold' : 'bold'"></tidy-text>

            <!-- Handle Italic Text -->
            <tidy-text
              *ngSwitchCase="'italic'"
              [body]="formattedElement.content"
              [translate]="false"
              [class]="allBold ? 'italic all-bold' : 'italic'"></tidy-text>

            <!-- Handle Underline Text -->
            <tidy-text
              *ngSwitchCase="'underline'"
              [body]="formattedElement.content"
              [translate]="false"
              [class]="allBold ? 'underline all-bold' : 'underline'"></tidy-text>

            <!-- Handle Strikethrough Text -->
            <tidy-text
              *ngSwitchCase="'strikethrough'"
              [body]="formattedElement.content"
              [translate]="false"
              [class]="allBold ? 'strikethrough all-bold' : 'strikethrough'"></tidy-text>

            <!-- Handle Links -->
            <tidy-text
              *ngSwitchCase="'link'"
              [actionBody]="formattedElement.content"
              (action)="openLink(formattedElement.url)"
              [class]="allBold ? 'link all-bold' : 'link'"></tidy-text>
            <!-- Handle Paragraphs (plain text) -->
            <tidy-text
              *ngSwitchDefault
              [body]="formattedElement.content"
              [translate]="false"
              [class.all-bold]="allBold"></tidy-text>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-template #plainContent>
        <tidy-text [body]="element.content" [translate]="false" [class.all-bold]="allBold"></tidy-text>
      </ng-template>
    </tidy-row>

    <!-- Handle Bold Text -->
    <tidy-row *ngSwitchCase="'bold'">
      <tidy-text
        [body]="element.content"
        [translate]="false"
        [class]="allBold ? 'bold all-bold' : 'bold'"></tidy-text>
    </tidy-row>

    <!-- Handle Italic Text -->
    <tidy-row *ngSwitchCase="'italic'">
      <tidy-text
        [body]="element.content"
        [translate]="false"
        [class]="allBold ? 'italic all-bold' : 'italic'"></tidy-text>
    </tidy-row>

    <!-- Handle Underline Text -->
    <tidy-row *ngSwitchCase="'underline'">
      <tidy-text
        [body]="element.content"
        [translate]="false"
        [class]="allBold ? 'underline all-bold' : 'underline'"></tidy-text>
    </tidy-row>

    <!-- Handle Strikethrough Text -->
    <tidy-row *ngSwitchCase="'strikethrough'">
      <tidy-text
        [body]="element.content"
        [translate]="false"
        [class]="allBold ? 'strikethrough all-bold' : 'strikethrough'"></tidy-text>
    </tidy-row>

    <!-- Handle Links -->
    <tidy-row *ngSwitchCase="'link'">
      <tidy-text
        [actionBody]="element.content"
        (action)="openLink(element.url)"
        [class]="allBold ? 'link all-bold' : 'link'">
      </tidy-text>
    </tidy-row>

    <!-- Fallback for unknown types -->
    <tidy-row *ngSwitchDefault>
      <tidy-text [body]="element.content" [translate]="false" [class.all-bold]="allBold"></tidy-text>
    </tidy-row>
  </ng-container>
</ng-container>
